import styles from './index.scss'
import { Button } from 'antd-mobile'
import EquityActivate from '../EquityActivate'

import icon from './ico_detail.png'
import { disabledInfoIcon, disabledCheckIcon } from './svg'

type PropsType = {
  onSelect?: () => void
  onConfirm?: () => void
  name: string
  date: string
  check?: boolean
  count: string
  unit?: string
  btnText?: string
  handleType?: 'check' | 'btn'
  secondaryColor?: string
  categoryType?: string
  equityExpirationEndText?: string
  activeParams?: Record<string, any>
  equityStatus: number
  disableDesc: string
  onReload?: () => void
  activeFunc?: () => void
  goToDetail?: () => void
}

export default function EquityActivateCard(props: PropsType) {
  const {
    name,
    date,
    count,
    unit,
    equityExpirationEndText,
    equityStatus,
    disableDesc,
    activeParams,
    onReload,
    activeFunc,
    goToDetail,
  } = props

  const isWaitActive = equityStatus === 5
  return (
    <div
      className={`${styles.equityCard} ${isWaitActive ? styles.active : ''}`}
    >
      {isWaitActive && <div className={styles.status}>待激活</div>}
      <div
        className={`${styles.upperPart}  ${
          !isWaitActive ? styles.disabled : ''
        }`}
      >
        <div className={styles.left}>
          <div className={styles.title}>{name}</div>
          <div className={styles.ogit}>
            {count}
            {unit && <span className={styles.unit}>{unit}</span>}
          </div>
        </div>
        <div className={`${styles.right}`}>
          {isWaitActive ? (
            <EquityActivate
              equityExpirationEndText={equityExpirationEndText}
              isNeedRealName={false}
              onReload={onReload}
              activeParams={activeParams}
              activeFunc={activeFunc}
            >
              <Button
                className={styles.btn}
                shape="rounded"
                type="submit"
                size="small"
              >
                激活权益
              </Button>
            </EquityActivate>
          ) : (
            <i
              className={styles['disabled-icon']}
              dangerouslySetInnerHTML={{ __html: disabledCheckIcon }}
            ></i>
          )}
        </div>
      </div>
      <div className={styles.nextPart}>
        <div className={styles.date}> {date}</div>
        {isWaitActive && (
          <div className={styles.info} onClick={goToDetail}>
            <span>查看详情</span>
            <span className={styles.icon}>
              <img src={icon} />
            </span>
          </div>
        )}
      </div>
      <div className={styles['disabled-info-wrap']}>
        <span className={styles.icon}>
          <i dangerouslySetInnerHTML={{ __html: disabledInfoIcon }}></i>
        </span>
        <span className={styles['disabled-info']}>{disableDesc}</span>
      </div>
    </div>
  )
}
